import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import favicon from '../assets/img/favicon.png';


const Head = ({ pageTitle, title, path, description, imageUrl, type, datePublished }) => {
    const data = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    siteUrl,
                    title
                }
            }
        }
    `);

    // remove html and double quotes  from description
    const stripHTMLregex = /(<([^>]+)>)/ig;
    const multiSpaceRegex = /\s\s+/g;
    const stripDblQuoteRegex = /["]+/g;
    const cleanDescription = (description)? description.replace(stripHTMLregex, " ").replace(multiSpaceRegex, " ").trim().replace(stripDblQuoteRegex, ""):"";

    // convert date to iso
    //const publishDate = new Date(datePublished);
    //const isoDateStr = publishDate.toISOString();

    return (
        <>
            <Helmet title={`${pageTitle} | ${data.site.siteMetadata.title}`} />
            <Helmet>
                <link rel="icon" href={favicon} />
​
                <meta name="twitter:card" content="summary_large_image"></meta>
                <meta name="twitter:title" content={title}></meta>
                <meta name="twitter:description" content={cleanDescription}></meta>
                <meta name="twitter:image" content={imageUrl}></meta>
​
                <meta property="og:locale" content="en_GB" />
                <meta property="og:site_name" content={data.site.siteMetadata.title} />
                <meta property="og:title" content={title}></meta>
                <meta property="og:url" content={data.site.siteMetadata.siteUrl + path}></meta>
                <meta property="og:description" content={cleanDescription}></meta>
                <meta property="og:image" content={imageUrl}></meta>
                <meta property="og:type" content={type} />

                {/*-- begin cookie yes banner --*/}
                <script id="cookieyes" type="text/javascript" src="https://cdn-cookieyes.com/client_data/54ad3d0910e7e7ea5644cd13/script.js"></script>
                {/* -- end cookie yes banner -- */}

                <script type="text/javascript">
                    {`
                        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-MTV3V9KS');

                    `}
                </script>
                <script type="text/javascript">
                    {`
                        _linkedin_partner_id = "6454218";
                        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
                        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
                    `}
                </script>
                <script type="text/javascript">
                    {`
                        (function(l) {
                        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
                        window.lintrk.q=[]}
                        var s = document.getElementsByTagName("script")[0];
                        var b = document.createElement("script");
                        b.type = "text/javascript";b.async = true;
                        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
                        s.parentNode.insertBefore(b, s);})(window.lintrk);
                    `}
                </script>
            </Helmet>
        </>
    )
}

export default Head